import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SortIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SortIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M6.04273 19.6036C5.84838 19.6036 5.65403 19.5294 5.50568 19.381L2.22254 16.0979C1.92582 15.8012 1.92582 15.3205 2.22254 15.0238C2.51925 14.7271 2.99993 14.7271 3.29664 15.0238L6.04274 17.7699L8.78883 15.0238C9.08554 14.7271 9.56622 14.7271 9.86293 15.0238C10.1596 15.3205 10.1596 15.8012 9.86293 16.0979L6.57979 19.381C6.43144 19.5294 6.23707 19.6036 6.04273 19.6036Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.04273 18.8158C5.62337 18.8158 5.28314 18.4756 5.28314 18.0562V5.15558C5.28314 4.73623 5.62337 4.396 6.04273 4.396C6.46208 4.396 6.80231 4.73623 6.80231 5.15558V18.0562C6.80231 18.4756 6.46208 18.8158 6.04273 18.8158Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2404 5.91517H12.8449C12.4255 5.91517 12.0853 5.57494 12.0853 5.15558C12.0853 4.73623 12.4255 4.396 12.8449 4.396H21.2404C21.6598 4.396 22 4.73623 22 5.15558C22 5.57494 21.6598 5.91517 21.2404 5.91517Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2404 10.4781H12.8449C12.4255 10.4781 12.0853 10.1379 12.0853 9.71855C12.0853 9.2992 12.4255 8.95896 12.8449 8.95896H21.2404C21.6598 8.95896 22 9.2992 22 9.71855C22 10.1379 21.6598 10.4781 21.2404 10.4781Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2404 15.0406H12.8449C12.4255 15.0406 12.0853 14.7004 12.0853 14.281C12.0853 13.8617 12.4255 13.5214 12.8449 13.5214H21.2404C21.6598 13.5214 22 13.8617 22 14.281C22 14.7004 21.6598 15.0406 21.2404 15.0406Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2404 19.6036H12.8449C12.4255 19.6036 12.0853 19.2633 12.0853 18.844C12.0853 18.4246 12.4255 18.0844 12.8449 18.0844H21.2404C21.6598 18.0844 22 18.4246 22 18.844C22 19.2633 21.6598 19.6036 21.2404 19.6036Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SortIcon;
